import React from 'react';
import { Carousel } from 'react-bootstrap'
import axios from "axios";
import configData from "../../config/config.json";

class LoginPageSlides extends React.Component {

	state = {
		numberOfSlides: 0,
		altText: {
			"one": "Please refer to the ADA compliant slides link for a text-only pdf file.",
			"two": "Please refer to the ADA compliant slides link for a text-only pdf file.",
			"three": "Please refer to the ADA compliant slides link for a text-only pdf file.",
			"four": "Please refer to the ADA compliant slides link for a text-only pdf file.",
			"five": "Please refer to the ADA compliant slides link for a text-only pdf file.",
			"six": "Please refer to the ADA compliant slides link for a text-only pdf file."
		}
	}

	fetchAltText() {
		fetch(configData.BROWSER_ROUTER_BASENAME + "/counties/" + configData.COUNTY_DIRECTORY + "/slideAltText.json")
			.then((res) => res.text())
			.then((text) => {
				const altText = JSON.parse(text);
				this.setState({
					altText
				});
			})
			.catch((e) => console.error(e));
	}

	componentDidMount() {
		axios.get(configData.LANDSHARK_SERVER_URL + "auth/loginPageSlides", { withCredentials: true })
			.then(
				(response) => {
					this.setState({
						numberOfSlides: response.data.content.numberOfSlides
					}, this.fetchAltText()
				);
				},
				(error) => {
					//   handleError(error, this.props.history);
				}
			);
	}

	render() {
		const slide1 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/one.jpg";
		const slide2 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/two.jpg";
		const slide3 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/three.jpg";
		const slide4 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/four.jpg";
		const slide5 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/five.jpg";
		const slide6 = configData.BROWSER_ROUTER_BASENAME + "/counties/" +  configData.COUNTY_DIRECTORY + "/six.jpg";

		if (!this.state.numberOfSlides || this.state.numberOfSlides <= 1) {
			return (
				<Carousel style={{ boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)" }} autoPlay={false} controls={false} indicators={false} >
					{
						this.state.numberOfSlides === 1 &&
						<Carousel.Item>
							<img border="0" src={slide1} alt="ONE" class="img-fluid" />
						</Carousel.Item>
					}
				</Carousel>
			)
		}

		return (
			<>
				<Carousel style={{boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)"}}  autoPlay={true} controls={true} indicators={true}  interval={30000} >
					{
						this.state.numberOfSlides >= 1 &&
						<Carousel.Item>
							<img border="0" src={slide1} alt={this.state.altText.one} class="img-fluid" />
						</Carousel.Item>
					}
					{
						this.state.numberOfSlides >= 2 &&
						<Carousel.Item>
							<img border="0" src={slide2} alt={this.state.altText.two} class="img-fluid" />
						</Carousel.Item>
					}
					{
						this.state.numberOfSlides >= 3 &&
						<Carousel.Item>
							<img border="0" src={slide3} alt={this.state.altText.three} class="img-fluid" />
						</Carousel.Item>
					}
					{
						this.state.numberOfSlides >= 4 &&
						<Carousel.Item>
							<img border="0" src={slide4} alt={this.state.altText.four} class="img-fluid" />
						</Carousel.Item>
					}
					{
						this.state.numberOfSlides >= 5 &&
						<Carousel.Item>
							<img border="0" src={slide5} alt={this.state.altText.five} class="img-fluid" />
						</Carousel.Item>
					}
					{
						this.state.numberOfSlides >= 6 &&
						<Carousel.Item>
							<img border="0" src={slide6} alt={this.state.altText.six} class="img-fluid" />
						</Carousel.Item>
					}
				</Carousel>
			</>
		)
	}
}

export default LoginPageSlides;